import { ISelectOptionDTO } from "@hooks/dtos/forms/ISelectDTO";
import React, { useState } from "react";
interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  animated?: boolean;
  register?: any;
  options?: ISelectOptionDTO[];
  value?: string;
  errorMessage?: string;
}

export function Select({
  label,
  className = "mb-3",
  animated,
  register,
  options,
  value,
  errorMessage,
  ...rest
}: IProps) {
  const [selectedOption, setSelectedOption] = useState<
    ISelectOptionDTO | undefined
  >();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = options?.find(
      (opt) => opt.value.toString() === e.target.value
    );
    setSelectedOption(selected);
    rest.onChange?.(e);
  };

  return (
    <>
      {animated && (
        <div className="form-floating">
          <select
            className={`form-select ${errorMessage ? "is-invalid" : ""}`}
            value={value}
            onChange={handleChange}
            {...register}
            {...rest}
          >
            <option>Selecione uma opção...</option>
            {options &&
              options.length > 0 &&
              options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
          </select>

          {selectedOption?.description && (
            <div className="mt-2">
              <small className="text-muted">{selectedOption.description}</small>
            </div>
          )}

          <label>{label}</label>
          {errorMessage && (
            <div className="invalid-feedback">{errorMessage}</div>
          )}
        </div>
      )}

      {!animated && (
        <div>
          {label && <label className="form-label text-white">{label}</label>}

          <select
            className="form-select"
            aria-label="Default select example"
            vaule={value}
            onChange={handleChange}
            {...register}
            {...rest}
          >
            <option>Selecione uma opção...</option>
            {options &&
              options.length > 0 &&
              options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
          </select>

          {selectedOption?.description && (
            <div className="mt-2">
              <small className="text-muted">{selectedOption.description}</small>
            </div>
          )}

          {errorMessage && (
            <div className="invalid-feedback">{errorMessage}</div>
          )}
        </div>
      )}
    </>
  );
}
